import ReactECharts from 'echarts-for-react';

interface AreaChartProps {
  data: Array<Record<string, any>>;
  xKey?: string;
  series: Array<{ key: string; name: string; color: string }>;
  height?: number;
  formatTooltip?: (value: number) => string;
}

export function AreaChart({ data, xKey = 'date', series, height = 280, formatTooltip = (v) => `$${v.toLocaleString()}` }: AreaChartProps) {
  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(30,30,40,0.95)',
      borderColor: 'rgba(255,255,255,0.1)',
      textStyle: { color: '#e5e5e5', fontSize: 12 },
      formatter: (params: any) => {
        const date = params[0]?.axisValue || '';
        const lines = params.map((p: any) => `<span style="color:${p.color}">●</span> ${p.seriesName}: ${formatTooltip(p.value)}`);
        return `<strong>${date}</strong><br/>${lines.join('<br/>')}`;
      },
    },
    grid: { left: 50, right: 16, top: 12, bottom: 28 },
    xAxis: {
      type: 'category',
      data: data.map(d => d[xKey]),
      axisLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
      axisLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 10 },
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 10, formatter: (v: number) => v >= 1000 ? `${(v / 1000).toFixed(0)}K` : String(v) },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.05)' } },
    },
    series: series.map(s => ({
      name: s.name,
      type: 'line',
      data: data.map(d => d[s.key]),
      smooth: true,
      symbol: 'none',
      lineStyle: { width: 2, color: s.color },
      areaStyle: {
        color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [
          { offset: 0, color: s.color + '40' },
          { offset: 1, color: s.color + '05' },
        ] },
      },
    })),
  };

  return <ReactECharts option={option} style={{ height }} notMerge lazyUpdate />;
}
